import { render, staticRenderFns } from "./consignmentReturnAction.vue?vue&type=template&id=c3e91872&scoped=true"
import script from "./consignmentReturnAction.vue?vue&type=script&lang=js"
export * from "./consignmentReturnAction.vue?vue&type=script&lang=js"
import style0 from "./consignmentReturnAction.vue?vue&type=style&index=0&id=c3e91872&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3e91872",
  null
  
)

export default component.exports